import { PropsWithChildren } from "react";
import React from "react";
import AppHeader from "../components/layout/app-header";
import AppFooter from "../components/layout/app-footer";
import { Box, Container } from "@mui/material";

interface BaseProps extends PropsWithChildren<any> {
    requiredString?: string,
    requiredNumber?: number,
    optionalBoolean?: boolean,
    optionalString?: string,
    optionalNumber?: number,
}

const defaultProps: BaseProps = {
    requiredString: '',
    requiredNumber: 0,
    optionalBoolean: true,
    optionalString: 'default',
    optionalNumber: 42,
}


const BaseComponent: React.FC<BaseProps> = (props) => {
    return (
        <React.Fragment>
            <AppHeader />
            <Box
                component="main"
                sx={{
                    minHeight: 'calc(100vh - 400px)',
                    backgroundColor: 'background.default',
                }}
            >
                <Container maxWidth="xl" sx={{ py: 4 }}>
                    {props.children}
                </Container>
            </Box>
            <AppFooter />
        </React.Fragment>
    );
};

BaseComponent.defaultProps = defaultProps;

export default BaseComponent;
